import {find, findIndex} from "min-dash";
import {Base} from "diagram-js/lib/model";
import {isAny} from "bpmn-js/lib/util/ModelUtil";
import Canvas from 'diagram-js/lib/core/Canvas';
import OrderingProvider from "diagram-js/lib/features/ordering/OrderingProvider";
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {connection} from "@ispm-shared/modules/bpmn";

var orders = [
  { type: 'bpmn:SubProcess', order: { level: 6 } },

  // handle SequenceFlow(s) like message flows and render them always on top
  {
    type: 'bpmn:SequenceFlow',
    order: {
      level: 3,
      containers: [
        'bpmn:Participant',
        'bpmn:FlowElementsContainer'
      ]
    }
  },

  // handle DataAssociation(s) like message flows and render them always on top
  {
    type: 'bpmn:DataAssociation',
    order: {
      level: 9,
      containers: [
        'bpmn:Collaboration',
        'bpmn:FlowElementsContainer'
      ]
    }
  },
  {
    type: 'bpmn:MessageFlow', order: {
      level: 9,
      containers: [ 'bpmn:Collaboration' ]
    }
  },
  {
    type: 'bpmn:Association',
    order: {
      level: 6,
      containers: [
        'bpmn:Participant',
        'bpmn:FlowElementsContainer',
        'bpmn:Collaboration'
      ]
    }
  },
  { type: 'bpmn:BoundaryEvent', order: { level: 8 } },
  {
    type: 'bpmn:Group',
    order: {
      level: 10,
      containers: [
        'bpmn:Collaboration',
        'bpmn:FlowElementsContainer'
      ]
    }
  },
  { type: 'bpmn:FlowElement', order: { level: 5 } },
  { type: 'bpmn:Participant', order: { level: -2 } },
  { type: 'bpmn:Lane', order: { level: -1 } }
];

export class CustomOrdering extends OrderingProvider {

  constructor(eventBus,private canvas: Canvas) {
    super(eventBus);
  }


  getOrdering(element: Base,newParent) {
    if (element.labelTarget) {
      return {
        parent: this.canvas.findRoot(newParent) || this.canvas.getRootElement(),
        index: -1
      };
    }

    var elementOrder = this.getOrder(element);

    if (elementOrder.containers) {
      newParent = this.findActualParent(element, newParent, elementOrder.containers);
    }

    var currentIndex = newParent.children.indexOf(element);

    var insertIndex = findIndex(newParent.children, (child) => {

      // do not compare with labels, they are created
      // in the wrong order (right after elements) during import and
      // mess up the positioning.
      if (!element.labelTarget && child.labelTarget) {
        return false;
      }

      return elementOrder.level < this.getOrder(child).level;
    });


    // if the element is already in the child list at
    // a smaller index, we need to adjust the insert index.
    // this takes into account that the element is being removed
    // before being re-inserted
    if (insertIndex !== -1) {
      if (currentIndex !== -1 && currentIndex < insertIndex) {
        insertIndex -= 1;
      }
    }

    return {
      index: insertIndex,
      parent: newParent
    };

  }

   findActualParent(element, newParent, containers) {

    var actualParent = newParent;

    while (actualParent) {

      if (isAny(actualParent, containers)) {
        break;
      }

      actualParent = actualParent.parent;
    }

    if (!actualParent) {
      throw new Error('no parent for <' + element.id + '> in <' + (newParent && newParent.id) + '>');
    }

    return actualParent;
  }

   computeOrder(element) {
    if (element.labelTarget) {
      return { level: 10 };
    }

    var entry = find(orders, function(o) {
      return isAny(element, [ o.type ]);
    });

    return entry && entry.order || { level: 1 };
  }

   getOrder(element) {

    var order = element.order;

    if (!order || ModelingUtil.getElementType(element) === connection) {
      element.order = order = this.computeOrder(element);
    }

    if (!order) {
      throw new Error('no order for <' + element.id + '>');
    }

    return order;
  }

}
